import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { CPPlaylistCategoriesService } from "../playlist-categories/cp_playlist-categories.service";
import { CPPlaylistsService } from "../services/cp_playlists.service";
import { CommonService } from "../services/common.service";
import { ScheduleService } from "../services/schedule.service";
import { AlertComponent } from "../alert/alert.component";
import { ConfirmComponent } from "../confirm/confirm.component";
import { Globals } from "../globals";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { ClientSampleService } from "../services/client_sample.service";
import { NgForm } from "@angular/forms";
import { FpSampleService } from "../services/fp_sample.service";

import {
  DropzoneComponent,
  DropzoneConfigInterface,
  DropzoneDirective,
} from "ngx-dropzone-wrapper";

import * as FileSaver from "file-saver";

@Component({
  selector: "app-fp-sample-playlist",
  templateUrl: "./fp-sample-playlist.component.html",
  styleUrls: ["./fp-sample-playlist.component.scss"],
  providers: [
    CPPlaylistsService,
    CPPlaylistCategoriesService,
    ScheduleService,
    CommonService,
    ClientSampleService,
    FpSampleService,
  ],
})
export class FpSamplePlaylistComponent implements OnInit {
  constructor(
    private chanelsService: CPPlaylistCategoriesService,
    private playlistServ: CPPlaylistsService,
    private scheduleService: ScheduleService,
    private commonService: CommonService,
    private clientsampleservice: ClientSampleService,
    private fpsampleservice: FpSampleService,
    private router: Router,
    private http: HttpClient,
    private globals: Globals,
    private route: ActivatedRoute
  ) {}

  public isLoad: boolean = false;
  public systemStatus = {
    status: "",
    called_in: "",
    next_expected_call: "",
  };
  isFocused = false;
  searchStr = ""; //Value of search input
  clientsearchStr = ""; // value for client search input
  entitySearchStr = "";
  entitySearchResult = [];
  usersList:any = []; //List of Clients
  usersListRaw:any = [];
  searchedPlaylists: any = []; //Array of search results
  searchPopupOpened = false; //Open search results popup
  sitesList: any = null; //List of sites
  chanelsList: any = null; //List of Channels
  playlists; //List of playlists
  archivePlaylists: any; // List OF Archive Playlist

  clientsList = [];
  selectedClient = "";

  /*
   Schedule information in edit popup
   {
    userId: - Client id,
    sitesList - sites list for select,
    siteId - selected site id,
    channelsList - channels list for select,
    channelId - selected channel id,
    playlistList - playlists for select,
    playlistId - selected playlist id,
    name - schedule name,
    begin_date - schedule start date,
    finish_date - schedule end date,
    begin_time - schedule start time,
    finish_time - schedule end time,
    bgColor - color for background in schedule table,
    txtColor - color for text in schedule table,
    recurrence_fl - value for schedule recurrence,
    random - value for schedule random,
    mastering_fl - value for schedule mastering,
    clash_distance - value for schedule clash distance,
    duration - schedule duration,
    duration_unit - schedule duration time unit,
    artistsNumber - count of artists in schedule,
    recurrence: {
      radio_value - Value for recurence time unit
      daily: {
        days - count of days
      },
      weekly: {
        week - count of weeks
        days - array of days
      },
      monthly: {
        month - count of monthes
        monthSelection - value for selection type,
        days - count of days,
        number - value for recurrence select,
        type - days of week
      },
      yearly: {
        year - count of years,
        monthes - list of monthes,
        monthSelection - value for selection type,
        number- value for recurrence select,
        type - days of week
      }
    },//Recurrence settings

   
   */
  schedule = {
    userId: null,
    sitesList: [],
    siteId: null,
    channelsList: [],
    channelId: null,
    playlistList: [],
    playlistId: null,
    name: "",
    begin_date: {
      year: "",
      month: "",
      day: "",
    },
    finish_date: {
      year: "",
      month: "",
      day: "",
    },
    begin_time: {
      hours: "00",
      minutes: "00",
    },
    //'00:00',
    finish_time: {
      hours: "00",
      minutes: "00",
    },
    //'00:00',
    bgColor: "#FFFFFF",
    txtColor: "#FF0000",
    recurrence_fl: "0",
    random: "0",
    mastering_fl: "0",
    clash_distance: "0",
    duration: "0",
    override_duration: {
      hours: "00",
      minutes: "00",
    },
    duration_unit: "mins",
    artistsNumber: 0,
    recurrence: {
      radio_value: "1",
      daily: {
        days: 1,
      },
      weekly: {
        week: 1,
        days: [],
      },
      monthly: {
        month: 1,
        monthSelection: "1",
        days: [],
        number: 1,
        type: "SU",
      },
      yearly: {
        year: 1,
        monthes: [],
        monthSelection: false,
        number: 1,
        type: "SU",
      },
    },
    mastering: {
      m_switch: "0",
      days: 1,
      months: 1,
      months_2: 1,
      every_week_day: 1,
      recurrence_dow: "MO",
    },
    onDemand: false,
  };
  /**
   Value for confirmation popup
   {
     id(integer) - ID of element for action(default null),
     type(integer) - type of function for action(default 1)
   }
   **/
  confirmValues = {
    id: null,
    type: 0,
  };
  /**
   Clear array of playlists
   */
  clearPlaylistsData() {
    this.playlists = null;
  }
  /**
   Clear array of archiveplaylists
   */
  clearArchivePlaylistsData() {
    this.archivePlaylists = null;
  }

  /**
   Clear array of channels
   */
  clearChanelsData() {
    this.checkedChanelId.id = null;
    this.chanelsList = null;
  }
  /**
   Show actions for selected client/site/channel
   {
    number - number of type action,
    id - client/site/channel id
  };
   */
  isShowActions = {
    number: null,
    id: null,
  };
  /*
   Selected Client information
   {
    id - Client id,
    name - Client name
   }
   */
  checkedUserId = {
    id: null,
    name: "",
  };
  /*
   Selected Site information
   {
    id - Site id,
    name - Site name
   }
   */
  checkedSiteId = {
    id: null,
    name: "",
  };
  /*
  Selected Channel information
  {
    id - Channel id,
    name - Channel name
  }
  */
  checkedChanelId = {
    id: null,
    name: "",
  };
  schedulesList: any = []; //Schedules list
  current_user = null; // information of logged user
  categoriesPopupOpened = false; //Open popup for edit categories
  tabs = {
    selected: false,
  };

  channeltabs = {
    selected: 1,
  };

  changingStatus = false;

  // selected channel for edit
  channelEditPopUpOpen = false;
  selectedChannel = {
    id: "",
    name: "",
  };

  //List of playlists
  /*
  Playlilst information in edit popup
  {
    id - playlist id,
    name - playlist name,
    status - playlist activity,
    channel - selected channel for playlist,
    site - selected site for playlist,
    description - playlist description,
    user - Client id,
    sitesList - sites list for select,
    channelsList - channels list for select
    countrycode-country code 
    countrycodeList-list of country with code
    edited_by user id store 
  }
   */
  playlistFields = {
    id: null,
    name: "",
    status: 1,
    site: null,
    user: null,
    sitesList: [],
    edited_by: null,
  };

  copyFields = {
    id: null,
    name: "",
    status: 1,
    site: null,
    user: null,
    sitesList: [],
    edited_by: null,
  };
  //For create New playlist PopUp
  create_new_playlistpopUp = false;
  copyFpSamplePlaylist = false;

  /*
  Channel information in edit popup
  {
    id - channel id,
    name - channel name,
    visible - channel activity,
    site - site id,
    user - client id
    sitesList - list of sites for select
  }
   */
  chanelFields = {
    id: null,
    name: "",
    visible: 1,
    site: null,
    user: null,
    sitesList: [],
  };

  /*
 Category information in edit popup
 {
   id - category id,
   name - category name,
   visible - category activity
 }
  */
  categoriesFields = {
    id: null,
    name: "",
    user: null,
  };
  /*
 Site information in edit popup
 {
   id - site id,
   name - site name,
   visible - site activity,
   user - client id
 }
  */
  subcategoryFields = {
    id: null,
    name: "",
    visible: 1,
    category: null,
    user_id: null,
  };
  sitePopupOpened = false; //Open popup for subcategory edit

  /**
 Open popup for edit sub categories information
 * @param e - event
 * @param scid - sub category id
 */

  public orderBy = "created_at";
  public order = "DESC";
  playlistStatusText = ["LIVE", "EDITING", "ARCHIVE"]; //Text for playlist status

  showchannelList = false;

  saveandManageplaylist: any; // return n save nad manage playlist;

  @ViewChild(AlertComponent, { static: true }) alert: AlertComponent; //Component of alert popup
  @ViewChild(ConfirmComponent, { static: true }) confirm: ConfirmComponent; //Component of confirm popup
  @ViewChild("comments") comments: ElementRef;
  @ViewChild(DropzoneDirective) directiveRef?: DropzoneDirective; //Dropzone component
  @ViewChild(DropzoneComponent, { static: true })
  componentRef?: DropzoneComponent; //Dropzone component

  ngOnInit() {
    this.commonService.getCurrentLoggedUser().subscribe((current_user) => {
      this.current_user = current_user;
      if (localStorage.getItem("fps_es_keyword") != null) {
        this.entitySearchStr = localStorage.getItem("fps_es_keyword");
        this.entitySearch(window.event);
      }
      this.updateClientsList();
      this.setCheckedElements();
      // this.getallcllient();
    });
  }

  /**
   Set param if input focused
   */
  focusInput() {
    this.isFocused = true;
  }
  /**
   Set param if input blured
   */
  blurInput() {
    this.isFocused = false;
  }

  /**
   Crear search results
   @param e - event
   * @returns {boolean}
   */
  clearSearch(e: any) {
    e.preventDefault();
    this.searchStr = "";
  }

  /**
   Get list of Clients
   */
  updateClientsList() {
    this.fpsampleservice.getClientsList().subscribe((clients:any) => {
      this.usersList = clients;
      this.usersListRaw = clients;

      if (this.checkedUserId.id && this.checkedUserId.name == "") {
        let user = this.usersList.find((x) => x.id == this.checkedUserId.id);
        this.checkedUserId.name = user.name;
      }
      this.isLoad = false;
    });
  }

  /**
  Set checked client,site,channel after back from edit playlist page
  */
  setCheckedElements() {
    this.route.queryParams.subscribe((params) => {
      if (params["uid"] != "" && params["uid"] != null) {
        this.checkedUserId.id = params["uid"];
        // this.scrollToElementUserList(this.checkedUserId.id);
        this.getSites(this.checkedUserId.id, "", 0);
      } else {
        this.checkedUserId.id = null;
      }
      if (params["cat"] != "" && params["cat"] != null) {
        this.checkedSiteId.id = params["cat"];
        this.showChanels("", this.checkedSiteId.id, "", 0);
      } else {
        this.checkedSiteId.id = null;
        this.sitesList = null;
      }
      this.isShowActions.number = 2;
      this.channeltabs.selected = 1;
    });
  }

  /**
   Show table of playlists
   * @param e - event
   * @param cid - channel id
   * @param name - channel name
   * @param num - type of action
   */
  showPlaylists(e, cid, name, num) {
    this.isShowActions.number = 3;
    if (num == 1 && this.checkedChanelId.id == cid) {
      this.checkedChanelId.id = null;
      this.checkedChanelId.name = "";
      this.playlists = [];
      this.schedulesList = [];
    } else {
      this.playlists = [];
      this.schedulesList = [];
      this.checkedChanelId.id = cid;
      this.checkedChanelId.name = name;
      this.updatePlaylists(0);
    }
  }

  /**
   Crear search results
   @param e - event
   * @returns {boolean}
   */
  clearEntitySearch(e) {
    this.isLoad = true;
    e.preventDefault();
    this.entitySearchStr = "";
    this.entitySearchResult = [];
    this.checkedUserId.id = null;
    this.checkedSiteId.id = null;
    this.checkedChanelId.id = null;
    this.checkedUserId.name = "";
    this.checkedSiteId.name = "";
    this.checkedChanelId.name = "";
    this.updateClientsList();
    localStorage.removeItem("fps_es_keyword");
  }

  search(e: any) {
    this.clearEntitySearch(e);
    e.preventDefault();
    if (this.searchStr != "") {
      if (this.searchStr.length < 6) {
        this.alert.alertOpen("Please enter minimum 6 characters to search", 1);
        return false;
      }
      this.playlistServ
        .searchPlaylists(this.searchStr)
        .subscribe((playlists: Array<any>) => {
          if (playlists != null) {
            console.log("playlist", playlists);
            const newPlaylists = playlists.filter((object) => {
              return object.cp_category.parent_id !== 1;
            });
            this.searchedPlaylists = newPlaylists;
          } else this.searchedPlaylists = [];
          this.searchPopupOpened = true;
        });
    }
    console.log(this.searchedPlaylists);
  }

  entitySearch(e) {
    this.alert.alertOpen("In Progress", 1);
    // localStorage.setItem("fps_es_keyword", this.entitySearchStr.toLowerCase());
    // this.sitesList = [];
    // this.checkedUserId.id = null;
    // this.checkedSiteId.id = null;
    // this.checkedChanelId.id = null;
    // this.checkedUserId.name = "";
    // this.checkedSiteId.name = "";
    // this.checkedChanelId.name = "";
    // e.preventDefault();
    // if (this.entitySearchStr != "") {
    //   this.isLoad = true;

    //   this.chanelsService
    //     .getSiteSearch(this.entitySearchStr.toLowerCase())
    //     .subscribe((sites: any) => {
    //       if (sites == undefined || sites.length == 0) {
    //         this.alert.alertOpen("No results", 1, 15);
    //         this.clearEntitySearch(e);
    //       }
    //       let data = [];
    //       for (var row in sites) {
    //         let children = [];
    //         for (var rowInner in sites[row]["children"]) {
    //           children.push(sites[row]["children"][rowInner]);
    //         }
    //         sites[row]["children"] = children;
    //         data.push(sites[row]);
    //       }
    //       this.entitySearchResult = data;
    //       console.log(this.entitySearchResult);
    //       this.sitesList = sites;
    //       this.isLoad = false;
    //     });
    // }
  }

  /**
   Actions after breadcrumbs click
   * @param num - number of back action
   * @returns {boolean}
   */
  resetCheckedElements(num) {
    if (num < 4) {
      this.checkedChanelId.id = null;
    }
    if (num < 3) {
      this.checkedSiteId.id = null;
    }
    if (num < 2) {
      this.checkedUserId.id = null;
    }
    return false;
  }

  /**
   Get List of sites
   * @param uid - user id
   * @param name - user name
   * @param num - number of action
   */
 
  getSites(uid, name, num) {
    this.tabs.selected = false;
    this.checkedSiteId.id = null;
    this.checkedSiteId.name = null;
    this.checkedChanelId.id = null;
    this.isShowActions.number = 1;
    this.clearChanelsData();
    this.clearPlaylistsData();

    if (num === 1 && this.checkedUserId.id === uid) {
      this.checkedUserId.id = null;
      this.checkedUserId.name = "";
    } else {
      this.checkedUserId.id = uid;
      this.checkedUserId.name = name;

      this.fpsampleservice.getChannelsByuser(uid).subscribe((sites: any) => {
        // const searchString = this.entitySearchStr.toLowerCase();
        // const filteredSites = this.filterSites(sites, searchString);
        this.sitesList = sites;//filteredSites;

        this.updateCheckedIds();
      });
    }
  }

  filterSites(sites, searchString) {
    return sites.filter((row) => this.searchf(row, searchString));
  }

  searchf(row, searchString) {
    return Object.keys(row).some((key) => {
      if (key === "entity_id" && typeof row[key] === "number") {
        return row[key] === parseFloat(searchString);
      } else if (key === "name" && typeof row[key] === "string") {
        return row[key].toLowerCase().includes(searchString);
      } else if (row[key] && typeof row[key] === "object") {
        return this.searchf(row[key], searchString);
      }
      return false;
    });
  }

  updateCheckedIds() {
    const site = this.sitesList.find((x) => x.id == this.checkedSiteId.id);
    if (this.checkedSiteId.id && this.checkedSiteId.name === "") {
      this.checkedSiteId.name = site?.name || "";
    }

    if (this.checkedChanelId.id && this.checkedChanelId.name === "") {
      const channel = site?.children.find(
        (x) => x.id == this.checkedChanelId.id
      );
      this.checkedChanelId.name = channel?.name || "";
    }
  }

  onSending(data): void {
    const file = data[0];
    const formData = data[2];
    formData.append("cid", this.selectedClient);
  }

  getParentEntityIDForSite(client_id) {
    let user = this.usersListRaw.find((x) => x.id == client_id);
    if (user)
      return {
        entity_id: user.entity_id,
        entity_name: user.first_name,
      };
    return false;
  }

  /**
   Open confirmation popup
   * @param id - id of action
   * @param t - text for popup
   * @returns {boolean}
   */
  openConfirmPopup(id, t) {
    var text = "Do you want to delete this client?";
    if (t == 1) text = "Do you want to delete this sub-category?";
    if (t == 2) text = "Do you want to delete this channel?";
    if (t == 3) text = "Do you want to delete this playlist?";
    if (t == 4) text = "Do you want to delete schedule?";
    if (t == 5)
      text = "Would you like to set this schedule for a indefinite date?";
    if (t == 6) text = "Do you want to delete Document?";
    if (t == 7) text = "Do you want to delete the profile statement?";
    if (t == 8) text = "Do you want to sync the changes to distribution group?";
    if (t == 9) text = "Do you want to hawk this site?";
    if (t == 10) text = "Do you want to mark this site as complete?";
    if (t == 11) text = "Do you want to cancel the hawk for this site?";

    this.confirmValues.id = id;
    this.confirmValues.type = t;
    this.confirm.confirmOpen(text);
    return false;
  }

  /**
   Click inside element
   * @param e - event
   *@param uid- selected client_id
   */
  clickedInside(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  /**
   Confirm action in confirmation popup
   * @param e - event
   */
  isConfirm(e) {
    if (e) {
      if (this.confirmValues.type == 0) this.deleteUser(this.confirmValues.id);
      else if (this.confirmValues.type == 1)
        this.deleteSite(this.confirmValues.id, 1);
      else if (this.confirmValues.type == 2)
        this.deleteSite(this.confirmValues.id, 2);
      else if (this.confirmValues.type == 3)
        this.deletePlaylist(this.confirmValues.id);
      // else if (this.confirmValues.type == 4)
      //   this.deleteSchedule(this.confirmValues.id);
      // else if (this.confirmValues.type == 5) this.createSchedule();
      // else if (this.confirmValues.type == 6)
      //   this.deleteDocument(this.confirmValues.id);
      // else if (this.confirmValues.type == 7)
      //   this.deleteProfileRaw(this.confirmValues.id);
      // else if (this.confirmValues.type == 8)
      //   this.syncToDg(this.confirmValues.id);
      // else if (this.confirmValues.type == 9)
      //   this.reHawkSiteLevel(this.confirmValues.id);
      // else if (this.confirmValues.type == 10)
      //   this.forceHawk(this.confirmValues.id);
      // else if (this.confirmValues.type == 11)
      //   this.cancelHawk(this.confirmValues.id);
    }
  }

  /**
   Delete Client
   * @param uid - Client id
   */
  deleteUser(uid) {
    this.chanelsService.deleteClient(uid).subscribe((user) => {
      this.updateClientsList();
      this.checkedUserId.id = null;
      this.checkedSiteId.id = null;
      this.checkedChanelId.id = null;
      let currentUser = this.usersList.find((x) => x.id == uid);
      this.alert.alertOpen(
        "Client " + currentUser.company_name + " deleted successfully!",
        0
      );
    });
  }

  /**
   Delete site/channel
   * @param id - site/channel id
   * @param num - type of action 1-delete site, 2-delete channel
   */
  deleteSite(id, num) {
    this.fpsampleservice.deleteCategory(id).subscribe((siteDel) => {
      this.getSites(this.checkedUserId.id, "", 0);
      if (num == 1) {
        this.alert.alertOpen("SubCategory deleted", 0);
        this.showChanels("", this.checkedSiteId.id, "", 0);
      } else if (num == 2) {
        this.alert.alertOpen("Channel deleted", 0);
      }
    });
    this.getSites(this.checkedUserId.id, "", 0);
  }

  /**
   Delete playlist
   * @param id - playlist id
   */
  deletePlaylist(id) {
    this.fpsampleservice.deletePlaylist(id).subscribe((playlistDel) => {
      this.alert.alertOpen("Playlist deleted", 0);
      if (this.searchPopupOpened) {
        this.search(window.event);
      }
      this.updatePlaylists(0);
    });
  }

  /**
   Get playlists
   * @param num - type of action
   */
  updatePlaylists(num) {
    if (num == 0) {
      if (this.checkedSiteId.id != null) {
        this.fpsampleservice
          .getPlaylists(this.checkedSiteId.id)
          .subscribe((playlists) => {
            this.playlists = playlists;
          });
      }
    }
  }

  /**
   Show channels from selected site
   * @param e - event
   * @param sid - site id
   * @param name - site name
   * @param num - number of action type
   */
  showChanels(e, sid, name, num) {
    this.isShowActions.number = 2;
    this.checkedChanelId.id = null;
    this.clearPlaylistsData();
    this.playlistFields.site = sid;
    this.clearArchivePlaylistsData();
    if (num == 1 && this.checkedSiteId.id == sid) {
      this.checkedSiteId.id = null;
      this.checkedSiteId.name = "";
    } else {
      this.checkedSiteId.id = sid;
      this.checkedSiteId.name = name;
    }
    if (this.checkedUserId.id == null) {
      let site = this.entitySearchResult.find(
        (x) => x.id == this.checkedSiteId.id
      );
      let user = this.usersList.find((x) => x.id == site.client_id);
      this.checkedUserId.id = user.id;
      this.checkedUserId.name = user.first_name;
    }
    this.updatePlaylists(0);
    this.updateArchivePlayList();
  }

  openUserPopup(e, uid) {
    console.log("hello");
    return;
  }

  popupClose(e) {
    this.categoriesPopupOpened = false;
    this.create_new_playlistpopUp = false;
    this.copyFpSamplePlaylist = false;
    this.sitePopupOpened = false;
    this.clientsearchStr = "";
    this.clientsList = [];
    this.blurInput();
    return false;
  }

  /**
  Open popup for edit category information
  * @param e - event
  * @param cid - categoryId
  * @returns {boolean}
  */
  openCategoriesPopup(e, cid) {
    this.focusInput();
    this.categoriesFields.user = this.current_user.id;
    if (cid == null) {
      this.categoriesFields.id = null;
    } else {
      this.categoriesFields.id = cid;
      // this.playlistCatsServ.getPlaylistsCategories(cid).subscribe((category:any) => {
      // this.categoriesFields.name = category[0].name;
      // });
    }
    this.categoriesPopupOpened = !this.categoriesPopupOpened;
    return false;
  }

  /**
   Update category information
   * @param e - event
   * @param {NgForm} form - form
   * @returns {boolean}
   */
  categoryUpdate(e, form: NgForm) {
    if (this.categoriesFields.name == "") {
      this.alert.alertOpen("Please enter category name", 1);
      return false;
    }
    
    var str = Object.keys(form.value)
      .map(function (key) {
        var val = encodeURIComponent(form.value[key]);
        if (val == "null" || val == null) {
          val = "";
        }
        return encodeURIComponent(key) + "=" + val;
      })
      .join("&");
    if (this.categoriesFields.id == null) {
      this.fpsampleservice.createCategory(str, 1).subscribe((category) => {
        if (category["error"]) {
          this.alert.alertOpen(category["error"], 1);
        } else {
          this.alert.alertOpen("Category added", 0);
        }
        this.updateClientsList();
        this.popupClose(e);
      });
    } else {
      // this.fpsampleservice.updatePlaylistCategory(this.categoriesFields.id, str).subscribe((category:any) => {
      // this.updateCategoriesList();
      this.alert.alertOpen("Playlist updated", 0);
      // });
    }
    
  }

  /**
   *
   * @param e
   */
  onoptionselect(e: any) {
    this.clientsearchStr = e.target.value;
    document.getElementById("list").style.display = "none";
  }

  openPopUpforEdit(e: any, sid: any, sname: string) {
    this.selectedChannel.id = sid;
    this.selectedChannel.name = sname;
    this.channelEditPopUpOpen = true;
  }

  chaneleditPopUpClose(e: any) {
    this.selectedChannel.id = "";
    this.selectedChannel.name = "";
    this.channelEditPopUpOpen = false;
    return false;
  }

  selectTab(tabId) {
    this.channeltabs.selected = tabId;
  }

  /**
     Actions when changed user in select
     * @param e - event
     * @param num - type of action in popup
     */
  userChange(e, num) {
    if (e.target.value == null) {
      if (num == 1) {
        this.chanelFields.sitesList = [];
      } else if (num == 2) {
        this.playlistFields.sitesList = [];
      } else if (num == 3) {
        this.copyFields.sitesList = [];
      }
    } else {
      this.updateSites(e.target.value, num);
    }
  }

  /**
 Get sites list
 * @param uid - user id
 * @param num - number of edit popup
 */
  updateSites(uid, num) {
    this.fpsampleservice.getChannelsByuser(uid).subscribe((sites: any) => {
      if (num == 1) {
        this.chanelFields.sitesList = sites || [];
      } else if (num == 2) {
        this.playlistFields.sitesList = sites || [];
      } else if (num == 3) {
        this.copyFields.sitesList = sites || [];
      }
    });
  }

  openPlaylistPopup(e: any, pid: any) {
    this.popupClose(e);
    this.playlistFields.id = pid;
    this.playlistFields.edited_by = this.current_user.id;
    // this.searchPopupOpened = false;
    if (this.playlistFields.id == null) {
      // Reset fields for new playlist
      this.playlistFields.name = ''; // Clear previous name
      this.playlistFields.sitesList = [];
      
      if (this.checkedUserId.id != null) {
        this.playlistFields.user = this.checkedUserId.id;
        this.updateSites(this.playlistFields.user, 2);
      } else {
        this.playlistFields.user = null;
      }
    } else {
      this.fpsampleservice.getPlaylistByid(pid).subscribe((playlist: any) => {
        this.playlistFields.id = playlist.id;
        this.playlistFields.user = playlist.fp_sample_category_id;
        this.updateSites(playlist.fp_sample_category_id, 2);
        this.playlistFields.site = playlist.fp_sample_subcategory_id;
        this.playlistFields.name = playlist.name;
      });
    }
    this.focusInput();
    this.create_new_playlistpopUp = !this.create_new_playlistpopUp;
    return false;
  }

  /**
 Update playlist information
 * @param e - event
 * @param {NgForm} form - form
 * @param 0 is for simaple save 1 is used for save and trasfer to manage page 
 * @returns {boolean}
 */
  playlistUpdate(e, form: NgForm, savemange = null) {
    if (!this.playlistFields.name || this.playlistFields.name.trim() === '') {
      this.alert.alertOpen("Please enter a Playlist Name", 1);
      return false;
    }

    if (this.playlistFields.site == null) {
      this.alert.alertOpen("Please select SubCategory", 1);
      return false;
    }

    var str = Object.keys(form.value)
      .map(function (key) {
        var val = encodeURIComponent(form.value[key]);
        if (val == "null" || val == null) {
          val = "";
        }
        return encodeURIComponent(key) + "=" + val;
      })
      .join("&");
    if (this.playlistFields.user != null) {
      if (this.playlistFields.id == null) {
        this.fpsampleservice.createPlaylist(str).subscribe((playlists: any) => {
          if (playlists.error == undefined) {
            this.alert.alertOpen("Playlist added", 0);
            this.updatePlaylists(0);
          } else {
            this.alert.alertOpen(playlists.error, 1);
          }
        });
      } else {
        this.fpsampleservice
          .updatePlaylist(this.playlistFields.id, str)
          .subscribe((playlists: any) => {
            if (playlists.error == undefined) {
              this.alert.alertOpen("Playlist updated", 0);
              this.updatePlaylists(0);
            } else {
              this.alert.alertOpen(playlists.error, 1);
            }
          });
      }
    } else {
      this.alert.alertOpen("Please select Category", 1);
    }
    this.create_new_playlistpopUp = false;
  }

  /**
    Set status for playlist
    * @param e - event
    * @param pid - playlist id
    * @param sid - site id
    */

  statusChange(e, pid) {
    e.preventDefault();
    if (this.changingStatus) {
      this.alert.alertOpen(
        "Please wait! The previous status change request is in progress.",
        1
      );
      return false;
    }

    this.isLoad = true;
    this.changingStatus = true;
    this.fpsampleservice.setStatus(pid, e.target.value).subscribe((status) => {
      this.updatePlaylists(0);
      this.updateArchivePlayList();
      this.alert.alertOpen(
        "Status successfully changed to " +
          this.playlistStatusText[e.target.value] +
          "!",
        0
      );
      this.changingStatus = false;
      this.isLoad = false;
    });
  }

  updateArchivePlayList() {
    if (this.checkedSiteId.id != null) {
      this.fpsampleservice
        .getArchivePlaylists(this.checkedSiteId.id)
        .subscribe((playlists) => {
          this.archivePlaylists = playlists;
        });
    }
  }

  setOrderTC(order) {
    if (this.orderBy == order) {
      if (this.order == "DESC") this.order = "ASC";
      else this.order = "DESC";
    } else {
      this.orderBy = order;
    }
    if (this.order == "DESC") {
      this.playlists.sort((a, b) => (a.order > b.order ? 1 : -1));
    } else {
      this.playlists.sort((a, b) => (a.order > b.order ? -1 : 1));
    }
  }

  /**
Cliek link to edit sample client playlist
* @param id - playlist id
*/
  manageClick(id) {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        playlistID: id,
        pcat: this.checkedSiteId.id,
        uid: this.checkedUserId.id,
      },
    };
    this.router.navigate(
      ["manage-sample-foundation-playlists"],
      navigationExtras
    );
  }

  openSitePopup(e, sid) {
    this.subcategoryFields.id = sid;
    this.subcategoryFields.user_id = this.current_user.id;
    if (this.subcategoryFields.id == null) {
      if (this.checkedUserId.id != null) {
        this.subcategoryFields.category = this.checkedUserId.id;
      } else {
        this.subcategoryFields.category = null;
      }
    } else {
      this.fpsampleservice.getCategoriesbyid(sid).subscribe((cat: any) => {
        this.subcategoryFields.name = cat.name;
        this.subcategoryFields.category = cat.fp_sample.id;
      });
    }
    this.focusInput();
    this.sitePopupOpened = !this.sitePopupOpened;
    return false;
  }

  subcategory($event, form: NgForm) {
    var str = Object.keys(form.value)
      .map(function (key) {
        var val = encodeURIComponent(form.value[key]);
        if (val == "null" || val == null) {
          val = "";
        }
        return encodeURIComponent(key) + "=" + val;
      })
      .join("&");
    if (this.subcategoryFields.category != null) {
      if (this.subcategoryFields.id == null) {
        this.fpsampleservice.createSubCategory(str).subscribe((subcat: any) => {
          if (subcat.error == undefined) {
            this.alert.alertOpen("SubCategory name added", 0);
            this.showChanels("", this.checkedSiteId.id, "", 0);
            this.getSites(this.checkedUserId.id, "", 0);
          } else {
            this.alert.alertOpen(subcat.error, 1);
          }
        });
      } else {
        this.fpsampleservice
          .updatesubCategory(this.subcategoryFields.id, str)
          .subscribe((subcat: any) => {
            if (subcat.error == undefined) {
              this.alert.alertOpen("SubCategory name updated", 0);
              this.showChanels("", this.checkedSiteId.id, "", 0);
              this.getSites(this.checkedUserId.id, "", 0);
            } else {
              this.alert.alertOpen(subcat.error, 1);
            }
          });
      }
    } else {
      this.alert.alertOpen("Please select Category", 1);
    }
    // this.getSites(this.checkedUserId.id, "", 0);
    this.sitePopupOpened = false;
  }

  openPopUpforCopy(id: any) {
    this.copyFields.id = id;
    this.copyFields.edited_by = this.current_user.id;
    this.fpsampleservice.getPlaylistByid(id).subscribe((playlist: any) => {
      this.copyFields.id = playlist.id;
      this.copyFields.user = playlist.fp_sample_category_id;
      this.copyFields.site = playlist.fp_sample_subcategory_id;
      this.updateSites(playlist.fp_sample_category_id, 3);
      this.copyFields.name = playlist.name;
    });
    this.focusInput();
    this.copyFpSamplePlaylist = !this.copyFpSamplePlaylist;
    return false;
  }

  fpSamplePlaylistCopy(e, form: NgForm, savemange = null) {
    var str = Object.keys(form.value)
      .map(function (key) {
        var val = encodeURIComponent(form.value[key]);
        if (val == "null" || val == null) {
          val = "";
        }
        return encodeURIComponent(key) + "=" + val;
      })
      .join("&");

    if (this.copyFields.user != null) {
      this.fpsampleservice
        .copyplaylist(this.copyFields.id, str)
        .subscribe((playlists: any) => {
          if (playlists.error == undefined) {
            this.alert.alertOpen("FP sample successfully copied.", 0);
            this.updatePlaylists(0);
          } else {
            this.alert.alertOpen(playlists.error, 1);
          }
        });
    } else {
      this.alert.alertOpen("Please select Category and SubCategory", 1);
    }
    this.copyFpSamplePlaylist = false;
  }
}
